import { z } from 'zod'
import { API_ERROR_CODES } from '../enums/api-error-code.enum.js'
import { loanIssueDtoSchema } from './loan-issue.dto.js'
import { underwritingFindingDtoSchema } from './underwriting-rule.dto.js'

/** Fields every error envelope may carry, whether or not it includes blocks. */
export const apiErrorEnvelopeSchema = z.object({
  message: z.string().optional(),
  error: z.string().optional(),
  statusCode: z.number().optional(),
  /** Application-specific error code (for example UNDERWRITING_BLOCKED). */
  code: z.enum(API_ERROR_CODES).optional(),
  /** Request validation failures, per field (the API's ZodValidationPipe). */
  details: z
    .object({
      formErrors: z.array(z.string()).optional(),
      fieldErrors: z.record(z.string(), z.array(z.string())).optional(),
    })
    .optional(),
})

/**
 * Error envelope. Status-block payloads validate findings and issues against
 * the same DTOs the success endpoints return. A block list that does not match
 * is dropped by the web client so a bad list cannot erase `message`.
 */
export const apiErrorBodySchema = apiErrorEnvelopeSchema.extend({
  findings: z.array(underwritingFindingDtoSchema).optional(),
  issues: z.array(loanIssueDtoSchema).optional(),
})

/** The subset of an error response body the UI consumes. */
export type ApiErrorBody = z.infer<typeof apiErrorBodySchema>
